// OK Box
//
// Simple OK popup, based on skinned box

yesNoBox = {};

yesNoBox.create = function(json) {

    yesNoBox.container = new PIXI.Container();
    return yesNoBox.container;

};

yesNoBox.initialise = function(json, object) {

    if (typeof(json.fontDefinition) === "undefined") {
        console.log("A font definition was not found for yesNoBox.");
    }

    yesNoBox.background = resourceManager.createObject("skinnedBox", "background", json.FQN, { textureName: json.textureName, width: json.width, height: json.height, cornerWidth: json.cornerWidth, cornerHeight: json.cornerHeight} );
    yesNoBox.container.visible = false;

    // Add a button to skinned box
    var yesBbutton = resourceManager.createObject("button", "yesButton", json.FQN, { center: true, text: "Yes", "fontDefinition": json.fontDefinition, fileName: json.buttonName, x: json.width * (2/3), y: json.height - json.cornerHeight-16 } );
    yesBbutton.enableButton(true);
    yesBbutton.onPressedCallback = function() {
        yesNoBox.container.visible = false;
        if(checkForDefined(yesNoBox.yesCallback)) yesNoBox.yesCallback();
    };

    var noBbutton = resourceManager.createObject("button", "noButton", json.FQN, { center: true, text: "No", "fontDefinition": json.fontDefinition, fileName: json.buttonName, x: json.width * (1/3), y: json.height - json.cornerHeight-16 } );
    noBbutton.enableButton(true);
    noBbutton.onPressedCallback = function() {
        yesNoBox.container.visible = false;
        if(checkForDefined(yesNoBox.noCallback)) yesNoBox.noCallback();
    };

    // Show info to player
    yesNoBox.infoText = resourceManager.createObject("text", "text", json.FQN, {x: json.width / 2, y: json.height / 3, fontDefinition: json.fontDefinition });
    yesNoBox.infoText.anchor.set(0.5);
};

yesNoBox.getFilesRequired = function(json) {
    var files = standardObjectFactory.getButtonFiles( {fileName:json.buttonName });
    files.push (ReflexLoader.rootResDir + json.textureName);
    return files;
};

yesNoBox.showPopup = function(text, yesCallback, noCallback) {
    // Store callbacks
    yesNoBox.yesCallback = yesCallback;
    yesNoBox.noCallback = noCallback;

    // Show text
    yesNoBox.infoText.text = text;
    yesNoBox.container.visible = true;
};

resourceManager.registerObjectType("yesNoBox", yesNoBox.create, yesNoBox.initialise, yesNoBox.getFilesRequired);
